export const fullMainSegments = [
  'manufacturersAllowed',
  'importersAllowed',
  'wholesalersAllowed',
  'endConsumersAllowed',
  'retailersAllowed',
];

export const mainSegmentsWithoutRetailers = [
  'manufacturersAllowed',
  'importersAllowed',
  'wholesalersAllowed',
  'endConsumersAllowed',
];

export const retailerSegments = [
  'hotelsAllowed',
  'restaurantsAllowed',
  'cafesAllowed',
  'retailChainsAllowed',
  'trafiksAllowed',
  'otherRetailersAllowed',
];
